import {DropdownMenu} from '@wandb/components';
import {get} from 'lodash';
import React from 'react';

import {type MetricValence} from '../../../util/runfeed';
import {useBaselineRun} from '../RunSelectorRunsContext';
import {
  useSetTableSettings,
  useTableSettings,
} from '../RunSelectorTableSettingsContext';
import type {WBTableColumn} from '../WBTable/types';
import {MenuItem} from './MenuItem';

type MetricValenceGroupProps = {
  column: WBTableColumn;
};

export function MetricValenceGroup({column}: MetricValenceGroupProps) {
  const tableSettings = useTableSettings();
  const setTableSettings = useSetTableSettings();
  const baselineRun = useBaselineRun();

  const deltaMetricsHiddenBySettings = tableSettings.showMetricDeltas === false;
  const showingDeltaMetrics = baselineRun && !deltaMetricsHiddenBySettings;

  if (column.key.section !== 'summary' || !showingDeltaMetrics) {
    return null;
  }

  const currentValence: MetricValence = get(
    tableSettings,
    ['metricValences', column.accessor],
    'neutral'
  );

  function handleSelectionChange(keys: 'all' | Set<React.Key>) {
    if (keys === 'all') {
      return;
    }
    const key = [...keys][0] as MetricValence | undefined;
    if (key) {
      setTableSettings(s => ({
        ...s,
        metricValences: {...s.metricValences, [column.accessor]: key},
      }));
    }
  }

  return (
    <DropdownMenu.Section
      selectedKeys={[currentValence]}
      selectionMode="single"
      onSelectionChange={handleSelectionChange}>
      <DropdownMenu.Header>Metric directionality</DropdownMenu.Header>
      <MenuItem icon="expand-up" id="higher-is-better">
        Higher values are best
      </MenuItem>
      <MenuItem icon="expand-down" id="lower-is-better">
        Lower values are best
      </MenuItem>
      <MenuItem icon="idle" id="neutral">
        Don't color deltas
      </MenuItem>
    </DropdownMenu.Section>
  );
}
